import * as React from 'react'
import Layout from '../components/layout'
import Header from '../components/header'
import BrochureImg from '../images/brochure.jpg'
import StarCircleImg from '../images/star-circle.png'

const Contact = () => {
  return (
    <Layout>
      <Header activePath="/contact"></Header>

      <div className="container">
        <div className="row">
          <div className="col-md-6 pt-5 text-center">
            <img src={StarCircleImg} style={{width: '50px'}} alt="" />
            <h1 className="mt-1 mb-5">Contact Info</h1>
            <ul style={{ listStyle: `none`, fontWeight: `bold`, lineHeight: 2, paddingLeft: 0 }}>
              <li>Phone: +82 31 766 8011 ~ 14</li>
              <li>Fax: +82 31 766 8015 </li>
              <li>Email: dyetco@dyetco.co.kr</li>
              <li>Website: http://www.dyetco.kr</li>
            </ul>
            <p className="mt-5 mb-5">
              <a href="/products" className="btn btn-product-list">Product list</a>
            </p>
          </div>
          <div className="col-md-6">
            <img src={BrochureImg} style={{width: '100%'}} alt="" />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Contact
